<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    submitTitle="Submit"
    icon="fa-money-check-edit-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="!isDenyMode">
        <NotificationBarTitle>Warning: This will cancel the purchase order!</NotificationBarTitle>
      </NotificationBar>
      <FormRow label="Denied Reason" v-if="isDenyMode">
        <FormInputTextArea placeholder="Denied Reason" v-model="responseInfo.deniedReason" field="deniedReason" />
      </FormRow>
      <FormRow label="Cancel Reason" v-if="!isDenyMode">
        <FormInputTextArea placeholder="Cancel Reason" v-model="responseInfo.cancelledReason" field="cancelledReason" />
      </FormRow>      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "DenyPurchaseOrderDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    isDenyMode: {
      type: Boolean,
      default: true
    },
    purchaseOrderId: Number
  },
  data() {
    return {
      responseInfo: {},
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      if(this.isDenyMode)
        return 'Deny Purchase Order'
      else
        return 'Cancel Purchase Order'
    }
  },
  methods: {
    show(stockData) {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        deniedReason: this.responseInfo.deniedReason,
        cancelledReason: this.responseInfo.cancelledReason
      }

      if(this.$props.isDenyMode) {
        this.$apiService.purchasingService.denyPurchaseOrder(this.purchaseOrderId, updateData)
        .then(response => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      } else {
        this.$apiService.purchasingService.cancelPurchaseOrder(this.purchaseOrderId, updateData)
        .then(response => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      }
    },
  }
}
</script>